import { Box, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Header from './Header';

export default props => {
    return (
        <>
            <Header />
            <Box flexGrow={1}>{props.children}</Box>
            <Stack direction="row" alignItems='center' justifyContent="center" py={4}>
                <Typography fontSize={13}><Link component={RouterLink} to="/chat-bot">Suporte</Link> - <Link component={RouterLink} to="/politicas">Políticas</Link> - <Link component={RouterLink} to="/privacidade">Privacidade</Link> - Versão {localStorage.getItem('current_version')}</Typography>
            </Stack>
        </>
    );
};
